var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ios-badge-component",class:_vm.classObject},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://apps.apple.com/br/app/paguecombitcoin/id1511333416?utm_source=website&utm_medium=badge","target":"_blank"}},[_c('img',{staticClass:"link-img",attrs:{"alt":"Disponível no Apple Store","src":"/assets/img/app-store-badge.png"}})])
}]

export { render, staticRenderFns }